"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidNovageSkincareConfiguration = void 0;
const isValidNovageSkincareConfiguration = configuration => Boolean(configuration?.environment && configuration.partnerId);
exports.isValidNovageSkincareConfiguration = isValidNovageSkincareConfiguration;